import Marquee from "react-fast-marquee";

const DEFAULT_ITEMS = [
  "Preventive Cardiology",
  "Non-Invasive Care",
  "Consultant Cardiologist",
  "Women's Heart Health",
  "Echocardiography",
  "Heart Check-up Varanasi",
];

export default function EditorialMarquee({ items = DEFAULT_ITEMS, dark = false }) {
  return (
    <div
      data-testid="editorial-marquee"
      className={`py-6 md:py-8 border-y ${dark ? "bg-brand-deep border-white/10" : "bg-mint border-line"}`}
    >
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-display italic text-3xl md:text-5xl px-10 md:px-16 ${
                dark ? "text-mint" : "text-brand-deep"
              }`}
            >
              {item}
            </span>
            <span className={`text-2xl md:text-4xl ${dark ? "text-brand" : "text-brand"}`}>✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
